import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "years-container" }
const _hoisted_2 = ["onClick", "onKeydown"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.annees, (annee) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "year",
        key: annee,
        onClick: ($event: any) => (_ctx.emitSelect(annee)),
        onKeydown: [
          _withKeys(_withModifiers(($event: any) => (_ctx.emitSelect(annee)), ["prevent"]), ["enter"]),
          _withKeys(_withModifiers(($event: any) => (_ctx.emitSelect(annee)), ["prevent"]), ["space"])
        ],
        tabindex: "0",
        role: "button"
      }, [
        _createElementVNode("span", null, _toDisplayString(annee), 1)
      ], 40, _hoisted_2))
    }), 128))
  ]))
}